import apiClient from './apiClient';

export type RefillRequestStatus =
  | 'pending'
  | 'under_review'
  | 'approved'
  | 'denied'
  | 'fulfilled'
  | 'cancelled';

export type RefillRequestSource =
  | 'whatsapp'
  | 'telegram'
  | 'portal'
  | 'phone'
  | 'in_person';

export interface RefillRequest {
  id: string;
  tenantId: string;
  patientId: string;
  assignedProviderId: string | null;
  status: RefillRequestStatus;
  source: RefillRequestSource;
  medicationText: string | null;
  prescriptionId: string | null;
  notes: string | null;
  reviewedAt: string | null;
  reviewedById: string | null;
  decisionReason: string | null;
  sourceMessageId: string | null;
  createdAt: string;
  patient?: {
    id: string;
    firstName: string;
    lastName: string;
  };
}

function unwrap<T>(envelope: unknown): T {
  const e = envelope as { data?: T } & T;
  return (e?.data ?? e) as T;
}

export async function refillPendingCount(
  mine = true,
): Promise<number> {
  const res = await apiClient.get('/refills/pending-count', {
    params: { mine: mine ? 'true' : 'false' },
  });
  const payload = unwrap<{ count: number }>(res.data);
  return payload.count ?? 0;
}

export async function listMyRefills(
  status?: RefillRequestStatus,
): Promise<RefillRequest[]> {
  const res = await apiClient.get('/refills/mine', {
    params: status ? { status } : undefined,
  });
  return unwrap<RefillRequest[]>(res.data);
}

export async function approveRefill(
  id: string,
  reason?: string,
): Promise<RefillRequest> {
  const res = await apiClient.post(`/refills/${id}/approve`, { reason });
  return unwrap<RefillRequest>(res.data);
}

export async function denyRefill(
  id: string,
  reason: string,
): Promise<RefillRequest> {
  const res = await apiClient.post(`/refills/${id}/deny`, { reason });
  return unwrap<RefillRequest>(res.data);
}

export async function markRefillFulfilled(id: string): Promise<RefillRequest> {
  const res = await apiClient.post(`/refills/${id}/fulfilled`, {});
  return unwrap<RefillRequest>(res.data);
}
